export default "__VITE_ASSET__CLpgo7Ke__"